import { api } from '../index';

export const getPromocodes = promocode => api.get(`/promocodes/get/${promocode}`);
export const Promocodes = () => api.get('/promocodes');
